<div
    *ngIf="mention"
    [style.display]="selected ? '' : 'none'"
>
    <div class="agpr-mentionInsightsExplorerTab-toolbar">
        <agpr-tabs
            class="agpr-mentionInsightsExplorerTab"
            [variableHeaderWidth]="true"
            [selectedTabIndex]="selectedTabIndex"
            (selectedTabIndexChange)="tabChange($event)"
            (addNewTrigger)="openInsightCreator(true)"
            [addNewDisabled]="!mention.canGenerateInsight"
            [addNewTab]="'Briefings.analysis.customInsight.new.click'"
        >
            <agpr-tab
                [id]="'mentionInsightsExplorerTab_quickInsight'"
                [heading]="'Mention.workbench.insights.quickInsights'"
            >
            </agpr-tab>
            <agpr-tab
                [id]="'mentionInsightsExplorerTab_customInsight'"
                [heading]="'Mention.workbench.insights.customInsights'"
            >
            </agpr-tab>
            <agpr-tab
                *ngIf="mention.mentionId"
                [id]="'mentionInsightsExplorerTab_savedInsight'"
                [heading]="'Mention.insightsExplorerTab.savedInsights' | localize: { count: mention.insights?.length ??  0 }"
            ></agpr-tab>
        </agpr-tabs>
    </div>

    <agpr-scroll-panel>
        <div
            *ngIf="selectedTabIndex === insightTabTypes.QUICK_INSIGHTS && prompts"
            class="agpr-mentionInsightsExplorerTab-insights"
        >
            <agpr-message
                *ngIf="!mention.canGenerateInsight"
                [severity]="messageSeverities.info"
            >
                {{ 'Mention.workbench.insights.contentLicenseLimitations' | localize }}
            </agpr-message>

            <div class="agpr-mentionInsightsExplorerTab-languageSelector-container">
                <h4
                    id="mentionInsightsExplorerTab_languageSelector_label"
                    class="agpr-mentionInsightsExplorerTab-languageSelector-heading"
                >
                    {{ 'Mention.insightsExplorerTab.quickInsights.languageSelector.label' | localize }}
                </h4>

                <div class="agpr-mentionInsightsExplorerTab-languageSelector">
                    <agpr-dropdown
                        [id]="'mentionInsightsExplorerTab_lanaguageSelector-dropdown'"
                        [formControl]="languageFormControl"
                        [options]="promptLanguageOptions"
                        ariaLabelledBy="mentionInsightsExplorerTab_languageSelector_label"
                    ></agpr-dropdown>
                </div>
            </div>

            <ul>
                <li
                    *ngFor="let prompt of prompts"
                    class="agpr-mentionInsightsExplorerTab-promptListItem"
                >
                    <agpr-insight-card
                        [id]="prompt.type + '_insightCard'"
                        [label]="'Mention.workbench.insights.system.' + prompt.type"
                        [infoCircleTooltip]="'Mention.workbench.insights.system.tooltip.' + prompt.type"
                        [generateDisabled]="!mention.canGenerateInsight"
                        [savable]="mention.mentionId && hasMentionInsightsEnabled && !prompt.noContentGenerated && !!(prompt.insightText || prompt.insightModel)"
                        [saved]="!!prompt.insightSaved"
                        [isEmpty]="!(prompt.insightText || prompt.insightModel)"
                        [isAiGenerating]="busy"
                        [isPromptGenerating]="prompt.generating"
                        [collapseOnCancel]="!prompt.keywords"
                        (generate)="generateInsight(prompt, false)"
                        (stopGeneration)="cancelGeneration(prompt)"
                        (save)="saveNewInsight(prompt)"
                        [preLabelIcon]="true"
                    >
                        <ng-container *ngIf="prompt.formGroup && hasMentionInsightsEnabled">
                            <div
                                class="agpr-mentionInsightsExplorerTab-keywordForm"
                                [formGroup]="prompt.formGroup"
                            >
                                <agpr-text-input-chips
                                    formControlName="keywords"
                                    [id]="prompt.type + '_keywords'"
                                    [disabled]="prompt.isGenerating$ | async"
                                    header="Mention.insightsExplorerTab.quickInsights.analysisContext.label"
                                    placeholder="Mention.insightsExplorerTab.quickInsights.analysisContext.placeholder"
                                ></agpr-text-input-chips>

                                <div class="agpr-mentionInsightsExplorerTab-generateButton-container">
                                    <agpr-button
                                        [id]="prompt.type + '_generateButton'"
                                        class="agpr-mentionInsightsExplorerTab-generateButton"
                                        [label]="prompt.insightText ? 'Mention.insightsExplorerTab.quickInsights.keywords.regenerate' :  'Mention.insightsExplorerTab.quickInsights.keywords.generate'"
                                        [style]="buttonTypes.tertiary"
                                        [tooltip]="prompt.formGroup.get('keywords')?.errors?.required? 'Mention.insightsExplorerTab.quickInsights.keywords.required'
                                                : (!isNewKeywords(prompt) ? 'Mention.insightsExplorerTab.quickInsights.keywords.different' : '')"
                                        tooltipPosition="top"
                                        [disabled]="(!isNewKeywords(prompt) && prompt.insightText) || busy || prompt.formGroup.get('keywords')?.errors?.required"
                                        (click)="generateInsight(prompt, true)"
                                    ></agpr-button>
                                </div>
                            </div>
                        </ng-container>

                        <div
                            *ngIf="hasMentionInsightsEnabled && !!(prompt.insightText || prompt.insightModel) && !prompt.noContentGenerated"
                            class="agpr-mentionInsightsExplorerTab-content"
                        >
                            <div
                                *ngIf="prompt.responseType === promptResponseTypes.PLAIN_TEXT && prompt.insightText"
                                [innerHTML]="prompt.insightText | setUlStyle | sanitizeHtml"
                            ></div>

                            <agpr-mie-interactive-list
                                *ngIf="prompt.responseType === promptResponseTypes.INTERACTIVE_LIST"
                                [isAiGenerating]="busy"
                                [prompt]="prompt"
                                [categories]="prompt?.insightModel?.categories"
                                (generateEntryInsight)="generateEntryInsight($event)"
                            ></agpr-mie-interactive-list>
                        </div>

                        <ng-container *ngIf="!hasMentionInsightsEnabled">
                            <agpr-mention-insight-upsell-card></agpr-mention-insight-upsell-card>
                        </ng-container>

                        <agpr-message
                            class="agpr-mentionInsightsExplorerTab-noContentMessage"
                            *ngIf="prompt.noContentGenerated"
                            [severity]="messageSeverities.noContent"
                        >
                            {{ prompt.insightText }}
                        </agpr-message>
                    </agpr-insight-card>
                </li>
            </ul>
        </div>
        @if (selectedTabIndex === insightTabTypes.CUSTOM) {
            <div
                class="agpr-mentionInsightsExplorerTab-insights"
            >
                <agpr-message
                    *ngIf="!mention.canGenerateInsight"
                    [severity]="messageSeverities.info"
                >
                    {{ 'Mention.workbench.insights.contentLicenseLimitations' | localize }}
                </agpr-message>

                @if (customPrompts.length) {
                    <ul>
                        <li
                            *ngFor="let prompt of customPrompts"
                            class="agpr-mentionInsightsExplorerTab-promptListItem"
                        >
                            <agpr-insight-card
                                [id]="prompt.type + '_insightCard' + prompt.customInsightId"
                                [label]="prompt.name"
                                [generateDisabled]="!mention.canGenerateInsight"
                                [savable]="mention.mentionId && hasMentionInsightsEnabled && !prompt.noContentGenerated && !!(prompt.insightText || prompt.insightModel)"
                                [saved]="!!prompt.insightSaved"
                                [isEmpty]="!(prompt.insightText || prompt.insightModel)"
                                [isAiGenerating]="busy"
                                [isPromptGenerating]="prompt.generating"
                                [collapseOnCancel]="!prompt.keywords"
                                [showEdit]="true"
                                (generate)="generateInsight(prompt, false)"
                                (stopGeneration)="cancelGeneration(prompt)"
                                (save)="saveNewInsight(prompt)"
                                (editPromptClicked)="openInsightCreator(false, prompt)"
                                [preLabelIcon]="true"
                            >
                                <div
                                    *ngIf="hasMentionInsightsEnabled && !!(prompt.insightText || prompt.insightModel) && !prompt.noContentGenerated"
                                    class="agpr-mentionInsightsExplorerTab-content"
                                >
                                    <div
                                        *ngIf="prompt.responseType === promptResponseTypes.PLAIN_TEXT && prompt.insightText"
                                        [innerHTML]="prompt.insightText | setUlStyle | sanitizeHtml"
                                    ></div>
                                </div>

                                <ng-container *ngIf="!hasMentionInsightsEnabled">
                                    <agpr-mention-insight-upsell-card></agpr-mention-insight-upsell-card>
                                </ng-container>

                                <agpr-message
                                    class="agpr-mentionInsightsExplorerTab-noContentMessage"
                                    *ngIf="prompt.noContentGenerated"
                                    [severity]="messageSeverities.noContent"
                                >
                                    {{ prompt.insightText }}
                                </agpr-message>
                            </agpr-insight-card>
                        </li>
                    </ul>
                } @else {
                    <agpr-message
                        [severity]="messageSeverities.noContent"
                    >
                        {{ 'Mention.workbench.insights.customInsights.noContent' | localize }}
                    </agpr-message>
                }
            </div>
        }

        <div *ngIf="selectedTabIndex === insightTabTypes.SAVED_INSIGHTS">
            <ul class="agpr-mentionInsightsExplorerTab-insights">
                <li *ngFor="let insight of mention.insights">
                    <agpr-mention-insight-card
                        [insight]="insight"
                        (insightEdited)="updateInsight(insight)"
                        (insightPreferred)="preferInsight(insight)"
                        (insightDeleted)="deleteInsight(insight)"
                    ></agpr-mention-insight-card>
                </li>
            </ul>

            <agpr-message
                *ngIf="!mention?.insights?.length"
                class="agpr-mentionWorkbenchDialog-insights-rhp-InsightTab-noContent"
                [severity]="messageSeverities.noContent"
                [useWhiteBg]="true"
            >
                <span>
                    {{ 'Mention.workbench.insights.noContent' | localize }}
                </span>
            </agpr-message>
        </div>
    </agpr-scroll-panel>

    <ng-template #tabFooter>
        <agpr-action-bar>
            <ng-template #right>
                <agpr-button
                    *ngIf="mention?.mentionId"
                    [id]="'mentionInsightsExplorerTab_insightCreator'"
                    [style]="buttonTypes.tertiary"
                    label="Mention.insightsExplorerTab.openInsightCreator.buttonText"
                    (click)="openInsightCreator()"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </ng-template>

    <span
        role="region"
        class="sr-only"
        id="mentionInsightsExplorerTab_liveRegion"
        aria-live="polite"
    ></span>
</div>

<agpr-message
    *ngIf="!mention"
    [severity]="messageSeverities.noContent"
    [style.display]="selected ? '' : 'none'"
    [useWhiteBg]="true"
>
    {{ 'Mention.insightsExplorerTab.notAvailable' | localize }}
</agpr-message>
